{
  "Billing": "Facturation",
  "Return to App": "Retour à l'application",
  "Home": "Accueil",
  "Calendar": "Calendrier",
  "Dashboard": "Tableau de bord",
  "ATP": "ATP",
  "Subscriptions": "Abonnements",
  "Payment Methods": "Moyens de paiement",
  "Purchases": "Achats",
  "View Profile": "Voir le profil",
  "TrainingPeaks Athlete Since": "Athlète TrainingPeaks depuis",
  "TrainingPeaks Coach Since": "Coach TrainingPeaks depuis",
  "Invoice": "Facture",
  "No results": "Aucun résultat",
  "qtr": "trim.",
  "Show all transactions": "Afficher toutes les transactions",
  "No transactions found": "Aucune transaction trouvée",
  "Loading purchases": "Chargement des achats",
  "Error loading purchases": "Erreur lors du chargement des achats",
  "Active": "Actif",
  "Inactive": "Inactif",
  "Cancelled": "Annulé",
  "PastDue": "En retard",
  "Trialing": "Période d'essai",
  "Next Renewal": "Prochain renouvellement",
  "Manage": "Gérer",
  "plus tax": "hors taxes",
  "No subscriptions found": "Aucun abonnement trouvé",
  "No purchases found": "Aucun achat trouvé",
  "Show all": "Afficher tout",
  "Show less": "Afficher moins",
  "Date": "Date",
  "Description": "Description",
  "Amount": "Montant",
  "Status": "Statut",
  "Paid": "Payé",
  "Failed": "Échoué",
  "Pending": "En attente",
  "Refunded": "Remboursé",
  "Loading": "Chargement",
  "Error loading data": "Erreur lors du chargement des données",
  "month": "mois",
  "year": "an",
  "quarter": "trimestre",
  "mo": "mois",
  "yr": "an",
  "Default": "Par défaut",
  "Expires": "Expire",
  "Card ending in": "Carte se terminant par",
  "Flexible planning to fit your life": "Une planification flexible adaptée à votre vie",
  "Actionable Insights to keep you on track": "Des informations exploitables pour rester sur la bonne voie",
  "Strength training to avoid injury": "Renforcement musculaire pour éviter les blessures",
  "Ride the world inside on Virtual": "Parcourez le monde en intérieur avec Virtual",
  "Any sport, any device, any time": "Tous les sports, tous les appareils, à tout moment",
  "Annual": "Annuel",
  "Monthly": "Mensuel",
  "Billed USD $134.99/yr": "Facturé 134,99 USD/an",
  "Most Popular": "Le plus populaire",
  "$19.95 $11.25/mo": "19,95 $ 11,25 $/mois",
  "$19.95/mo": "19,95 $/mois",
  "Checkout": "Paiement",
  "Progress starts with Premium.": "Le progrès commence avec Premium.",
  "Add Card": "Ajouter une carte",
  "Close": "Fermer",
  "Primary": "Principale",
  "Delete": "Supprimer",
  "Make Primary": "Définir comme principale",
  "Error loading payment methods": "Erreur lors du chargement des moyens de paiement",
  "Your card has expired. Please add a new card.": "Votre carte a expiré. Veuillez ajouter une nouvelle carte.",
  "Unable to load payment form. Please try again later.": "Impossible de charger le formulaire de paiement. Veuillez réessayer plus tard.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "Des frais temporaires de 1,00 $ seront facturés pour valider votre moyen de paiement. Ils seront automatiquement remboursés.",
  "Payment method added successfully": "Moyen de paiement ajouté avec succès",
  "Default payment method updated": "Moyen de paiement par défaut mis à jour",
  "Payment method deleted": "Moyen de paiement supprimé",
  "Failed to set default payment method": "Impossible de définir le moyen de paiement par défaut",
  "Failed to update default payment method": "Impossible de mettre à jour le moyen de paiement par défaut",
  "Failed to delete payment method": "Impossible de supprimer le moyen de paiement",
  "Maximize Your Premium Subscription \n Before You Go!": "Profitez au maximum de votre abonnement Premium\navant de partir !",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Pédalez en intérieur grâce à notre expérience de cyclisme virtuel",
  "Strength Builder": "Créateur d'entraînements de force",
  "Create and save strength workouts": "Créez et enregistrez des entraînements de force",
  "Metrics Charts": "Graphiques de métriques",
  "Analyze metrics from your synced devices": "Analysez les métriques de vos appareils synchronisés",
  "Performance Metrics": "Métriques de performance",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Condition physique (CTL), fatigue (ATL) et forme (TSB)",
  "Peak Performances": "Meilleures performances",
  "Track and compare your best efforts": "Suivez et comparez vos meilleurs efforts",
  "NEW!": "NOUVEAU !",
  "Cancel Subscription": "Annuler l'abonnement",
  "Renew Subscription": "Renouveler l'abonnement",
  "Complimentary": "Gratuit",
  "Your complimentary access is active through": "Votre accès gratuit est actif jusqu'au",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Gardez vos objectifs en vue : renouvelez Premium pour rester sur la bonne voie jusqu'au jour de la course.",
  "Renew": "Renouveler",
  "Auto-Renew Off": "Renouvellement automatique désactivé",
  "Access through": "Accès jusqu'au",
  "Turn Auto-Renew On": "Activer le renouvellement automatique",
  "Are you sure you want to cancel coaching?": "Voulez-vous vraiment annuler le coaching ?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Atteindre vos objectifs nécessite le bon accompagnement. Avant d'annuler, dites-nous si vous avez besoin de suspendre, d'ajuster votre niveau de forfait ou de parler directement à un spécialiste Coach Match.",
  "Pause, Adjust, or Contact Support": "Suspendre, ajuster ou contacter l'assistance",
  "Yes, Cancel": "Oui, annuler",
  "Keep My Coaching": "Conserver mon coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Abonnement Coach Match : Suspendre, ajuster ou parler à un spécialiste",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Bonjour l'équipe Coach Match,\n\nJe vous contacte au sujet de mon abonnement coaching. Avant de décider d'annuler, je souhaiterais [suspendre mon abonnement / ajuster le niveau de mon forfait / parler à un spécialiste Coach Match].\n\nMon adresse e-mail de compte est : [Votre e-mail]\n\nMerci !",
  "Before you go...": "Avant de partir...",
  "What's the reason for canceling?": "Quelle est la raison de l'annulation ?",
  "Price / Financial Reasons": "Prix / Raisons financières",
  "The subscription cost no longer fits my budget.": "Le coût de l'abonnement ne correspond plus à mon budget.",
  "Injured / Health Reasons": "Blessure / Raisons de santé",
  "I'm unable to train due to injury or health.": "Je ne peux pas m'entraîner en raison d'une blessure ou de ma santé.",
  "Finished Goal Event": "Objectif atteint",
  "I completed my target race or event.": "J'ai terminé ma course ou mon événement cible.",
  "Poor Experience / Fit": "Mauvaise expérience / Inadapté",
  "The coaching style or program wasn't the right match.": "Le style de coaching ou le programme ne me correspondait pas.",
  "Temporary Pause / Restart Later": "Pause temporaire / Reprendre plus tard",
  "Life got busy — I'd like to come back when I'm ready.": "La vie est devenue chargée — j'aimerais revenir quand je serai prêt(e).",
  "Other": "Autre",
  "Optional: Why?": "Facultatif : Pourquoi ?",
  "Continue": "Continuer",
  "Keep Subscription": "Conserver l'abonnement"
}
